<template>
  <m-geo-box geo-option="zip" title="Zip Map">
    <m-geo-zip-map :geoType="5"
            pastZipType="zip"/>
  </m-geo-box>
</template>

<script>
import MGeoBox from "@/components/geo/MGeoBox";
import MGeoZipMap from "@/components/geo/MGeoZipMap";

export default {
  components: {
    MGeoBox,
    MGeoZipMap,
  },
  data() {
    return {};
  },
  computed: {
    zipTypes() {
      return this.$store.state.geo.zipTypes;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoZipMap.vue